import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { LegalPhaseRow } from './LegalPhaseRow';
import { ILegalPhaseTemplateFullObject } from '../../../../Interfaces/ILegalPhaseTemplate';

interface IProps {
  legalPhaseTemplateArray: ILegalPhaseTemplateFullObject[];
  choosenPhases: ILegalPhaseTemplateFullObject[];
  setChoosenPhases: Function;
}

export const LegalPhaseTable: React.FC<IProps> = ({
  legalPhaseTemplateArray,
  choosenPhases,
  setChoosenPhases,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={'5%'}></TableCell>
            <TableCell width={'5%'}></TableCell>
            <TableCell width={'20%'}>Bezeichnung</TableCell>
            <TableCell width={'10%'}>Vorgänger</TableCell>
            <TableCell width={'10%'}></TableCell>
            <TableCell width={'10%'}>Interne Maßnahme</TableCell>
            <TableCell width={'10%'}>Upload Mandanten</TableCell>
            <TableCell width={'10%'}>Upload Mitarbeiter</TableCell>
            <TableCell width={'10%'}>
              Auto. <span style={{ whiteSpace: 'nowrap' }}>E-Mail</span>
            </TableCell>
            <TableCell width={'10%'}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {legalPhaseTemplateArray
            .sort((a, b) => (a.Position < b.Position ? -1 : 1))
            .map(x => (
              <LegalPhaseRow
                key={`idLegalPhaseTemplate-${x.idLegalPhaseTemplate}`}
                currentPhase={x}
                legalPhaseTemplateArray={legalPhaseTemplateArray}
                choosenPhases={choosenPhases}
                setChoosenPhases={setChoosenPhases}
              />
            ))}
        </TableBody>
      </Table>
    </>
  );
};
